import { useFacilityContext } from '@aspendental/shared-components-web';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { DataLayerEvent } from '@src/enums/DataLayerEvent.enum';
import { dataLayer } from '@src/services/dataLayer';
type UseLanguagePreferenceTrackingProps = {
  stepName: string;
  webFacilityDetails?: ReturnType<typeof useFacilityContext>;
  brand?: string;
};
export function useLanguagePreferenceTracking({
  stepName,
  webFacilityDetails,
  brand = 'aspendental'
}: UseLanguagePreferenceTrackingProps) {
  const router = useRouter();
  const {
    locale
  } = router;
  const prevLocale = useRef<string>();
  useEffect(() => {
    if (prevLocale.current !== undefined && prevLocale.current !== locale) {
      dataLayer({
        event: DataLayerEvent.LanguageSelected,
        language_preference: locale === 'es-US' ? 'spanish' : 'english',
        brand,
        step_name: stepName,
        ...(webFacilityDetails?.officeInfo?.code && {
          website_selected_facility_id: webFacilityDetails.officeInfo.code
        }),
        ...(webFacilityDetails?.officeInfo?.name && {
          website_selected_facility_name: webFacilityDetails.officeInfo.name
        })
      });
    }
    prevLocale.current = locale;
  }, [locale]);
}